import { FlexProps } from '@chakra-ui/layout';

import { productSwitchConfigs } from './hooks/use-get-mapped-config';
import fastPhonicsIcon from './icons/fast_phonics.svg';
import mathseedsIcon from './icons/mathseeds.svg';
import primeIcon from './icons/prime.svg';
import readingEggsIcon from './icons/reading_eggs.svg';
import readingEggspressIcon from './icons/reading_eggspress.svg';
import threeEssentialsIcon from './icons/three_essentials.svg';
import writingLegendsIcon from './icons/writing_legends.svg';

export const mappedIcons = {
    fastPhonics: fastPhonicsIcon,
    mathSeeds: mathseedsIcon,
    prime: primeIcon,
    readingEggs: readingEggsIcon,
    readingEggspress: readingEggspressIcon,
    threeEssentials: threeEssentialsIcon,
    writingLegends: writingLegendsIcon
};

export type Icons = keyof typeof mappedIcons;

export type Config = keyof typeof productSwitchConfigs;

export enum NavigationUrls {
    threeEssentials = 'threeEssentialsUrl',
    reading = 'readingUrl',
    writing = 'writingUrl',
    mathematics = 'mathematicsUrl',
}

export type MenuConfigProps = {
    id: Config
    icons: Icons[]
    styles?: FlexProps
    navigationUrlId: NavigationUrls
}[];
